import { VoucherFormBanner } from '../../components/VoucherForm/Banner';
import { VoucherFormBooking } from '../../components/VoucherForm/Booking';
import { VoucherFormProvider } from '../../components/VoucherForm/Context';
import { VoucherFormDiscount } from '../../components/VoucherForm/Discount';
import { VoucherFormInformation } from '../../components/VoucherForm/Information';
import { VoucherFormQuantity } from '../../components/VoucherForm/Quantity';
import { VoucherFormStructure } from '../../components/VoucherForm/Structure';
import { VoucherFormSubmit } from '../../components/VoucherForm/Submit';
import { VoucherFormCountriesAndLines } from '../../components/VoucherForm/Rules/CountriesAndLines';
import { VoucherFormRulesTitle } from '../../components/VoucherForm/Rules';

import styles from './add-voucher.module.scss';

const AddAgtpepPage = () => {
  const VoucherFormInformationTemplate = {
    revenueType: 'Marketing',
    voucherType: 'AGTPEP',
    reasonField: false,
  };

  const VoucherFormStructureTemplate = {
    prefix: 'AGTPEP',
    length: 12,
  };

  const VoucherFormQuantityTemplate = {
    disabled: true,
  };

  const VoucherFormDiscountTemplate = {
    disabled: true,
    discountType: 'percentage_marketing',
    showFreeAncillaries: false,
  };

  const VoucherFormBookingTemplate = {
    usageType: 'single',
    disableAllowedPlatforms: false,
    disableValidity: false,
  };

  const VoucherFormCountriesAndLinesTemplate = {
    transportType: true,
  };

  return (
    <>
      <VoucherFormBanner title='Customer Service - Partner Agency Voucher' />
      <VoucherFormProvider>
        <form>
          <div className={styles.container}>
            <VoucherFormInformation template={VoucherFormInformationTemplate} />
            <VoucherFormQuantity template={VoucherFormQuantityTemplate} />
            <VoucherFormStructure template={VoucherFormStructureTemplate} />
            <VoucherFormDiscount template={VoucherFormDiscountTemplate} />
            <VoucherFormBooking template={VoucherFormBookingTemplate} />
          </div>
          <div className={styles.container}>
            <VoucherFormRulesTitle />
            <VoucherFormCountriesAndLines template={VoucherFormCountriesAndLinesTemplate} />
          </div>

          <VoucherFormSubmit />
        </form>
      </VoucherFormProvider>
    </>
  );
};

export default AddAgtpepPage;
